export default __webpack_public_path__ + "static/dispatch_ls-6ec88e1cf69c825699747b7a0a1d3217.jpeg";